// Generated by purs version 0.15.0
import * as $foreign from "./foreign.js";
import * as Specular_Internal_Incremental_Optional from "../Specular.Internal.Incremental.Optional/index.js";
var foreachUntil = function (array, fn) {
    return $foreign["_foreachUntil"](Specular_Internal_Incremental_Optional.none, array, fn);
};
export {
    _foreachUntil
} from "./foreign.js";
export {
    foreachUntil
};
//# sourceMappingURL=index.js.map
